import React from "react";
import CSSClasses from "./SportPicker.css";
import SportIcons from "../../../assets/fonts/sport_icons/style.css";
import { connect } from "react-redux";
import * as StoreActions from "../../../ReduxStore/Actions/ActionIndex";
import * as MostPlayedOptionIDs from "../../../HOCs/Constants/MostPlayedOptionID";

import LeagueButton from "../../UI/LeagueButton/LeagueButton";

import allSportsIcon from "../../../assets/images/icons/icon_all_sports.png";
import basketballIcon from "../../../assets/images/icons/icon_basketball.png";
import soccerIcon from "../../../assets/images/icons/icon_soccer.png";
import tennisIcon from "../../../assets/images/icons/icon_tennis.png";
import volleyballIcon from "../../../assets/images/icons/icon_volleyball.png";
import liwIcon from "../../../assets/images/icons/icon_liw.png";
import futsalIcon from "../../../assets/images/icons/icon_futsal.png";
import handballIcon from "../../../assets/images/icons/icon_handball.png";
import baseballIcon from "../../../assets/images/icons/icon_baseball.png";
import hockeyIcon from "../../../assets/images/icons/icon_hockey.png";
import badmintonIcon from "../../../assets/images/icons/icon_badminton.png";
import rugbyIcon from "../../../assets/images/icons/icon_rugby.png";
import footballIcon from "../../../assets/images/icons/icon_football.png";
import table_tennisIcon from "../../../assets/images/icons/icon_table_tennis.png";
import beach_volleyballIcon from "../../../assets/images/icons/icon_beach_volleyball.png";
import bowlsIcon from "../../../assets/images/icons/icon_bowls.png";
import dartsIcon from "../../../assets/images/icons/icon_darts.png";
import snookerIcon from "../../../assets/images/icons/icon_snooker.png";
import cricketIcon from "../../../assets/images/icons/icon_cricket.png";
import specialIcon from "../../../assets/images/icons/icon_special.png";

import beepHigh from "../../../assets/sounds/beep_high.mp3";

let _props = null;

const SportPicker = props => {
  _props = props;

  //polje sportova
  let sports = [
    {
      id: 1000,
      emmettID: 0,
      icon: SportIcons.sport_icon_magicwin,
      title: "Live Magic Win"
    },
    {
      id: 43,
      emmettID: 43,
      icon: SportIcons.sport_icon_alpine_skiing,
      title: "Alpine Skiing"
    },
    {
      id: 36,
      emmettID: 41,
      icon: SportIcons.sport_icon_athletics,
      title: "Athletics"
    },
    {
      id: 13,
      emmettID: 12,
      icon: SportIcons.sport_icon_aussie_rules,
      title: "Aussie Rules"
    },
    {
      id: 31,
      emmettID: 24,
      icon: SportIcons.sport_icon_badminton,
      title: "Badminton"
    },
    {
      id: 15,
      emmettID: 14,
      icon: SportIcons.sport_icon_bandy,
      title: "Bandy"
    },
    {
      id: 3,
      emmettID: 4,
      icon: SportIcons.sport_icon_baseball,
      title: "Baseball"
    },
    {
      id: 155,
      emmettID: 59,
      icon: SportIcons.sport_icon_basketball_3x3,
      title: "Basketball 3x3"
    },
    {
      id: 2,
      emmettID: 3,
      icon: SportIcons.sport_icon_basketball,
      rasterIcon: basketballIcon,
      title: "Basketball"
    },
    {
      id: 60,
      emmettID: 26,
      icon: SportIcons.sport_icon_beach_soccer,
      title: "Beach Soccer"
    },
    {
      id: 34,
      emmettID: 25,
      icon: SportIcons.sport_icon_beach_volleyball,
      title: "Beach Volleyball"
    },
    {
      id: 45,
      emmettID: 54,
      icon: SportIcons.sport_icon_bobsleighxxx,
      title: "Bobsleigh"
    },
    {
      id: 32,
      emmettID: 30,
      icon: SportIcons.sport_icon_bowls,
      title: "Bowls"
    },
    {
      id: 10,
      emmettID: 31,
      icon: SportIcons.sport_icon_boxing,
      title: "Boxing"
    },
    {
      id: 21,
      emmettID: 28,
      icon: SportIcons.sport_icon_cricket,
      title: "Cricket"
    },
    {
      id: 46,
      emmettID: 46,
      icon: SportIcons.sport_icon_cross_country,
      title: "Cross Country"
    },
    {
      id: 28,
      emmettID: 22,
      icon: SportIcons.sport_icon_curling,
      title: "Curling"
    },
    {
      id: 17,
      emmettID: 16,
      icon: SportIcons.sport_icon_cycling,
      title: "Cycling"
    },
    {
      id: 22,
      emmettID: 19,
      icon: SportIcons.sport_icon_darts,
      title: "Darts"
    },
    {
      id: 110,
      emmettID: 35,
      icon: SportIcons.sport_icon_esport_lol,
      title: "E-sports LoL"
    },
    {
      id: 24,
      emmettID: 29,
      icon: SportIcons.sport_icon_field_hockey,
      title: "Field Hockey"
    },
    {
      id: 102,
      emmettID: 53,
      icon: SportIcons.sport_icon_figure_skating,
      title: "Figure Skating"
    },
    {
      id: 7,
      emmettID: 8,
      icon: SportIcons.sport_icon_floorball,
      title: "Floorball"
    },
    {
      id: 16,
      emmettID: 15,
      icon: SportIcons.sport_icon_football,
      title: "American Football"
    },
    {
      id: 142,
      emmettID: 56,
      icon: SportIcons.sport_icon_formula_exxxx,
      title: "Formula E"
    },
    {
      id: 103,
      emmettID: 48,
      icon: SportIcons.sport_icon_freestyle_skiing,
      title: "Freestlye Skiing"
    },
    {
      id: 29,
      emmettID: 23,
      icon: SportIcons.sport_icon_futsal,
      title: "Futsal"
    },
    {
      id: 9,
      emmettID: 9,
      icon: SportIcons.sport_icon_golf,
      title: "Golf"
    },
    {
      id: 6,
      emmettID: 7,
      icon: SportIcons.sport_icon_handball,
      title: "Handball"
    },
    {
      id: 4,
      emmettID: 5,
      icon: SportIcons.sport_icon_hockey,
      title: "Hockey"
    },
    {
      id: 55,
      emmettID: 57,
      icon: SportIcons.sport_icon_horse_racing,
      title: "Horse Racing"
    },
    {
      id: 138,
      emmettID: 60,
      icon: SportIcons.sport_icon_kabaddi,
      title: "Kabaddi"
    },
    {
      id: 0,
      emmettID: 39,
      icon: SportIcons.sport_icon_lotto,
      title: "Lotto"
    },
    {
      id: 51,
      emmettID: 55,
      icon: SportIcons.sport_icon_lugexxx,
      title: "Luge"
    },
    {
      id: 117,
      emmettID: 36,
      icon: SportIcons.sport_icon_mma,
      title: "MMA"
    },
    {
      id: 11,
      emmettID: 10,
      icon: SportIcons.sport_icon_motorsport,
      title: "Motorsport"
    },
    {
      id: 47,
      emmettID: 45,
      icon: SportIcons.sport_icon_nordic_combined,
      title: "Nordic Combined"
    },
    {
      id: 30,
      emmettID: 37,
      icon: SportIcons.sport_icon_olympicsxxx,
      title: "Olympics"
    },
    {
      id: 61,
      emmettID: 27,
      icon: SportIcons.sport_icon_pesapallo,
      title: "Pesapallo"
    },
    {
      id: 25,
      emmettID: 47,
      icon: SportIcons.sport_icon_pool,
      title: "Pool"
    },
    {
      id: 38,
      emmettID: 58,
      icon: SportIcons.sport_icon_rink_hockey,
      title: "Rink Hockey"
    },
    {
      id: 12,
      emmettID: 11,
      icon: SportIcons.sport_icon_rugby,
      title: "Rugby"
    },
    {
      id: 81,
      emmettID: 40,
      icon: SportIcons.sport_icon_sailing,
      title: "Sailing"
    },
    {
      id: 105,
      emmettID: 51,
      icon: SportIcons.sport_icon_short_track,
      title: "Short Track"
    },
    {
      id: 104,
      emmettID: 52,
      icon: SportIcons.sport_icon_skeleton,
      title: "Skeleton"
    },
    {
      id: 48,
      emmettID: 44,
      icon: SportIcons.sport_icon_ski_jumping,
      title: "Ski Jumping"
    },
    {
      id: 19,
      emmettID: 17,
      icon: SportIcons.sport_icon_snooker,
      title: "Snooker"
    },
    {
      id: 49,
      emmettID: 50,
      icon: SportIcons.sport_icon_snowboard,
      title: "Snowboard"
    },
    {
      id: 106,
      emmettID: 33,
      icon: SportIcons.sport_icon_soccer_mythical,
      title: "Soccer Mythical"
    },
    {
      id: 1,
      emmettID: 2,
      icon: SportIcons.sport_icon_soccer,
      rasterIcon: soccerIcon,
      title: "Soccer"
    },
    {
      id: 18,
      emmettID: 38,
      icon: SportIcons.sport_icon_specials,
      title: "Specials"
    },
    {
      id: 50,
      emmettID: 49,
      icon: SportIcons.sport_icon_speed_skating,
      title: "Speed Skating"
    },
    {
      id: 37,
      emmettID: 34,
      icon: SportIcons.sport_icon_squash,
      title: "Squash"
    },
    {
      id: 127,
      emmettID: 42,
      icon: SportIcons.sport_icon_street_fighter_v,
      title: "Street Fighter V"
    },
    {
      id: 20,
      emmettID: 18,
      icon: SportIcons.sport_icon_table_tennis,
      title: "Table Tennis"
    },
    {
      id: 5,
      emmettID: 6,
      icon: SportIcons.sport_icon_tennis,
      rasterIcon: tennisIcon,
      title: "Tennis"
    },
    {
      id: 23,
      emmettID: 20,
      icon: SportIcons.sport_icon_volleyball,
      rasterIcon: volleyballIcon,
      title: "Volleyball"
    },
    {
      id: 26,
      emmettID: 21,
      icon: SportIcons.sport_icon_waterpolo,
      title: "Waterpolo"
    },
    {
      id: 14,
      emmettID: 13,
      icon: SportIcons.sport_icon_winter_sports,
      title: "Winter Sports"
    },
    {
      id: 108,
      emmettID: 32,
      icon: SportIcons.sport_icon_world_lottery,
      title: "World Lottery"
    },
    {
      id: -10,
      emmettID: -10,
      icon: SportIcons.sport_icon_world_lottery,
      title: "All Sports"
    }
  ];

  if (props.activeMostPlayedButtonID === MostPlayedOptionIDs.TOP_LEAGUES) {
    if (!props.leagueItems) {
      return null;
    }

    //napravi si u parovima
    let leagueGroups = [];

    for (let i = 0; i < props.leagueItems.length; i++) {
      let item1 = props.leagueItems[i];
      let item2 =
        i < props.leagueItems.length - 1 ? props.leagueItems[i + 1] : null;

      i++;

      leagueGroups.push({ item1: item1, item2: item2 });
    }

    //vrati za sve league items gumbek
    return (
      <div className={CSSClasses.container}>
        <audio
          ref={sound => {
            this.beepHigh = sound;
          }}
        >
          <source src={beepHigh} type="audio/mpeg" />
        </audio>
        {leagueGroups.map(lg => {
          let li1 = lg.item1;
          let li2 = lg.item2;

          return (
            <div className={CSSClasses.leagueButtonGroup}>
              <LeagueButton
                onButtonClicked={changeLeagueClick}
                titleCategory={li1.CategoryTitle}
                titleTournament={li1.TournamentTitle}
                key={li1.TournamentID}
                id={li1.TournamentID}
                isActive={li1.TournamentID === props.activeLeagueID}
                eventCount={li1.EventCount}
                sportID={li1.SportID}
              />
              {li2 ? (
                <LeagueButton
                  onButtonClicked={changeLeagueClick}
                  titleCategory={li2.CategoryTitle}
                  titleTournament={li2.TournamentTitle}
                  key={li2.TournamentID}
                  id={li2.TournamentID}
                  isActive={li2.TournamentID === props.activeLeagueID}
                  eventCount={li2.EventCount}
                  sportID={li2.SportID}
                />
              ) : (
                <div className={CSSClasses.btnPlaceholder}>&nbsp;</div>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  if (props.isPrematchPicker) {
    //ocisti sports
    let filteredSports = [];

    //filtriraj po listi
    let activeInfo = props.prematchPickerInfo;

    if (activeInfo !== null) {
      //sortiraj
      activeInfo.sort((a, b) => {
        return a.UIOrderIndex - b.UIOrderIndex;
      });

      //dodaj jos i rucno sve sportove, ali samo ako smijes
      //samo da nije kalendar na 9, to je ALL, tada ne smije
      //i nema ako je na prematch isto svih sportova
      if (
        props.activeCalendarItemID !== 9 &&
        props.activeMostPlayedButtonID !== MostPlayedOptionIDs.PREMATCH
      ) {
        filteredSports.push({
          id: -10,
          betRadarID: -10,
          icon: "",
          title: "Svi sportovi",
          matchCount: 0
        });
      }

      var shouldAddSports = true;

      if (
        props.activeMostPlayedButtonID === MostPlayedOptionIDs.SUPERTIP ||
        props.activeMostPlayedButtonID === MostPlayedOptionIDs.FAVORIT_PLUS
      ) {
        shouldAddSports = false;
      }

      if (shouldAddSports) {
        for (let i = 0; i < activeInfo.length; i++) {
          const el = activeInfo[i];

          //pronadji taj sport po id-u
          let sport = sports.find(x => x.emmettID === el.sportID);

          //guraj ga
          filteredSports.push({
            id: el.sportID,
            betRadarID: sport !== undefined ? sport.id : -1,
            icon: sport !== undefined ? sport.icon : "",
            title: el.title,
            matchCount: el.matchCount
          });
        }
      }
    }
    //i pregazi
    sports = filteredSports;
  } else {
    //ocisti sports
    let filteredSports = [];

    //filtriraj po listi
    let activeInfo = props.livePickerInfo;

    if (activeInfo !== null) {
      //sortiraj
      activeInfo.sort((a, b) => {
        return a.UIOrderIndex - b.UIOrderIndex;
      });

      for (let i = 0; i < activeInfo.length; i++) {
        const el = activeInfo[i];

        //pronadji taj sport po id-u
        let sport = sports.find(x => x.id === el.sportID);

        //guraj ga
        filteredSports.push({
          id: el.sportID,
          betRadarID: sport !== undefined ? sport.id : -1,
          icon: sport !== undefined ? sport.icon : "",
          title: el.title,
          matchCount: el.matchCount
        });
      }
    }
    //i pregazi
    sports = filteredSports;
  }

  return (
    <div className={CSSClasses.container}>
      <audio
        ref={sound => {
          this.beepHigh = sound;
        }}
      >
        <source src={beepHigh} type="audio/mpeg" />
      </audio>
      <ul className={CSSClasses.sportList}>
        {sports.map(sport => {
          let classes = [CSSClasses.sportList_item];

          let currentSportID = props.isPrematchPicker
            ? props.currentPrematchSportID
            : props.currentLiveSportID;

          //ako je bez magic wina a ovo je magic win, nistaa
          if (sport.id === 1000 && !props.hasMagicWin) {
            return null;
          }

          if (!props.isPrematchPicker) {
            switch (props.currentLiveSportID) {
              case 1: // soccer
                classes.push(CSSClasses.defaultBtnColorSoccer);
                break;
              case 2: //basketball
                classes.push(CSSClasses.defaultBtnColorBasketball);
                break;
              case 3: //baseball
                classes.push(CSSClasses.defaultBtnColorBaseball);
                break;
              case 4: //hockey
                classes.push(CSSClasses.defaultBtnColorHockey);
                break;
              case 5: //tennis
                classes.push(CSSClasses.defaultBtnColorTennis);
                break;
              case 6: //handball
                classes.push(CSSClasses.defaultBtnColorHandball);
                break;
              case 12: //rugby
                classes.push(CSSClasses.defaultBtnColorRugby);
                break;
              case 16: //Football
                classes.push(CSSClasses.defaultBtnColorFootball);
                break;
              case 19: //Snooker
                classes.push(CSSClasses.defaultBtnColorSnooker);
                break;
              case 20: //TableTennis
                classes.push(CSSClasses.defaultBtnColorTableTennis);
                break;
              case 23: //volleyball
                classes.push(CSSClasses.defaultBtnColorVolleyball);
                break;
              case 29: //futsal
                classes.push(CSSClasses.defaultBtnColorFutsal);
                break;
              case 31: //Badminton
                classes.push(CSSClasses.defaultBtnColorBadminton);
                break;
              default:
                break;
            }
          }

          let isLightTheme =
            props.isPrematchPicker !== true &&
            props.currentActiveLiveTheme === 2;

          if (isLightTheme) {
            //live theme
            classes.push(CSSClasses.lightTheme);
          }

          //dodaj aktiv ako je aktiv
          if (sport.id === currentSportID) {
            classes.push(CSSClasses.activeItem);

            if (props.isPrematchPicker !== true) {
              if (isLightTheme) {
                classes.push(CSSClasses.lightThemeActive);
              } else {
                classes.push(CSSClasses.live);
              }
              //classes.push(CSSClasses.live);
            }
          }

          return (
            <li
              className={classes.join(" ")}
              key={sport.id}
              onClick={() => {
                changeSport(sport.id, props);
              }}
            >
              <div className={CSSClasses.buttonBox}>
                {/* <span className={[sport.icon, CSSClasses.iconSpan].join(" ")} /> */}

                {getRasterIcon(sport.betRadarID)}

                <span className={CSSClasses.sportTitle}>{sport.title}</span>
                {props.isPrematchPicker !== true && sport.matchCount > 0 ? (
                  <div className={CSSClasses.matchCountBox}>
                    {sport.matchCount}
                  </div>
                ) : null}
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const getRasterIcon = sportID => {
  switch (sportID) {
    case -10:
      return (
        <img src={allSportsIcon} alt="" className={CSSClasses.rasterIcon} />
      );
    case 1:
      return <img src={soccerIcon} alt="" className={CSSClasses.rasterIcon} />;
    case 2:
      return (
        <img src={basketballIcon} alt="" className={CSSClasses.rasterIcon} />
      );
    case 3:
      return (
        <img src={baseballIcon} alt="" className={CSSClasses.rasterIcon} />
      );
    case 4:
      return <img src={hockeyIcon} alt="" className={CSSClasses.rasterIcon} />;
    case 5:
      return <img src={tennisIcon} alt="" className={CSSClasses.rasterIcon} />;
    case 6:
      return (
        <img src={handballIcon} alt="" className={CSSClasses.rasterIcon} />
      );
    case 12:
      return <img src={rugbyIcon} alt="" className={CSSClasses.rasterIcon} />;
    case 16:
      return (
        <img src={footballIcon} alt="" className={CSSClasses.rasterIcon} />
      );
    case 19:
      return <img src={snookerIcon} alt="" className={CSSClasses.rasterIcon} />;
    case 20:
      return (
        <img src={table_tennisIcon} alt="" className={CSSClasses.rasterIcon} />
      );
    case 21:
      return <img src={cricketIcon} alt="" className={CSSClasses.rasterIcon} />;
    case 22:
      return <img src={dartsIcon} alt="" className={CSSClasses.rasterIcon} />;
    case 23:
      return (
        <img src={volleyballIcon} alt="" className={CSSClasses.rasterIcon} />
      );
    case 29:
      return <img src={futsalIcon} alt="" className={CSSClasses.rasterIcon} />;
    case 31:
      return (
        <img src={badmintonIcon} alt="" className={CSSClasses.rasterIcon} />
      );
    case 32:
      return <img src={bowlsIcon} alt="" className={CSSClasses.rasterIcon} />;
    case 34:
      return (
        <img
          src={beach_volleyballIcon}
          alt=""
          className={CSSClasses.rasterIcon}
        />
      );
    case 1000:
      return <img src={liwIcon} alt="" className={CSSClasses.rasterIcon} />;
    default:
      return <img src={specialIcon} alt="" className={CSSClasses.rasterIcon} />;
  }
};

const changeSport = (value, props) => {
  props.sportChanged();

  //alert("CLOSE");
  if (this.beepHigh) {
    this.beepHigh.play();
  }

  //gasi akcije terminala
  props.setTerminalActionsActiveButton(0);

  if (props.isPrematchPicker) {
    props.onChangeSportPrematch(value);
    props.onChangeCurrentCategory(0); //po defaultu odaberi sve kategorije cim je sport promijenjen
    props.onChangeCurrentLeague(-1);

    //gasi prematch
    props.setShouldQuickCloseExtraBets(true);

    props.setIsShowingBonusInfo(false);
    props.onSetPrematchExtraBetsID(-1);
    props.setCanShowExtraPrematchBets(true);

    setTimeout(() => {
      props.setShouldQuickCloseExtraBets(false);
    }, 100);
  } else {
    //gasi live
    props.setShouldQuickCloseExtraBets(true);

    props.setIsShowingBonusInfo(false);
    props.onSetLiveExtraBetsID(-1);
    props.setCanShowExtraLiveBets(true);
    props.onChangeSportLive(value);

    setTimeout(() => {
      props.setShouldQuickCloseExtraBets(false);
    }, 100);
  }
};

const changeLeagueClick = id => {
  console.log("Button click.." + id);

  if (this.beepHigh) {
    this.beepHigh.play();
  }

  _props.onChangeCurrentLeague(id);

  //gasi akcije terminala
  _props.setTerminalActionsActiveButton(0);
};

const mapStateToProps = state => {
  return {
    activeLeagueID: state.rrNavigation.leagueID,
    currentLiveSportID: state.rrNavigation.liveSportID,
    currentPrematchSportID: state.rrNavigation.prematchSportID,
    livePickerInfo: state.rrSportEvent.activeLiveSports,
    prematchPickerInfo: state.rrSportEvent.activePrematchSports,
    currentActiveLiveTheme: state.rrAppState.currentActiveLiveTheme,
    activeCalendarItemID: state.rrNavigation.calendarItemID,
    activeMostPlayedButtonID: state.rrNavigation.mostPlayedButtonID,
    leagueItems: state.rrSportEvent.prematchLeagueItems,
    updateTimestamp: state.rrSportEvent.updateTimestamp //hack da povuce novi state i napravi rerender
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onChangeSportPrematch: sportID =>
      dispatch(StoreActions.ChangeSportPrematch(sportID)),
    onChangeSportLive: sportID =>
      dispatch(StoreActions.ChangeSportLive(sportID)),
    onSetLiveExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentLiveExtraBetsID(betsID)),
    setShouldQuickCloseExtraBets: shouldClose =>
      dispatch(StoreActions.SetShouldQuickCloseExtraBets(shouldClose)),
    setCanShowExtraLiveBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraLiveBets(canShow)),
    setIsShowingBonusInfo: isShown =>
      dispatch(StoreActions.SetIsShowingBonusInfo(isShown)),
    onChangeCurrentCategory: categoryID =>
      dispatch(StoreActions.ChangeCategoryItem(categoryID)),
    onChangeCurrentLeague: leagueID =>
      dispatch(StoreActions.ChangeLeagueItem(leagueID)),
    onSetPrematchExtraBetsID: betsID =>
      dispatch(StoreActions.ChangeCurrentPrematchExtraBetsID(betsID)),
    setCanShowExtraPrematchBets: canShow =>
      dispatch(StoreActions.SetCanShowExtraPrematchBets(canShow)),
    setTerminalActionsActiveButton: buttonID =>
      dispatch(StoreActions.SetTerminalActionsActiveButton(buttonID))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SportPicker);



// WEBPACK FOOTER //
// ./src/Components/Navigation/SportPicker/SportPicker.js